// Форматирование по ред-политике EasyX v1.1: длительности, относительное время, вес, количество.

const MONTHS = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']

const SEC = 1000
const MIN = 60 * SEC
const HOUR = 60 * MIN
const DAY = 24 * HOUR
const YEAR = 365 * DAY

const pad = (n: number) => String(n).padStart(2, '0')

// Округляем вниз до двух значащих цифр, разделитель — точка, хвостовые нули убираем.
const shortNumber = (value: number, subUnitDecimals: number) => {
  const decimals = value < 1 ? subUnitDecimals : value < 10 ? 1 : 0
  const factor = 10 ** decimals
  return String(Math.floor(value * factor) / factor)
}

// «от 500 сокращаем» — переходим на старшую единицу, когда набралось больше её половины.
const withUnit = (value: number, units: Array<[string, number]>, base: string, subUnitDecimals: number) => {
  for (const [label, size] of units) {
    if (value > size / 2) return `${shortNumber(value / size, subUnitDecimals)} ${label}`
  }
  return `${Math.floor(value)}${base ? ` ${base}` : ''}`
}

const COUNT_UNITS: Array<[string, number]> = [['млрд', 1e9], ['млн', 1e6], ['тыс', 1e3]]
const BYTE_UNITS: Array<[string, number]> = [['ТБ', 1024 ** 4], ['ГБ', 1024 ** 3], ['МБ', 1024 ** 2], ['КБ', 1024]]

export const formatCount = (value: number) => withUnit(Math.max(0, value), COUNT_UNITS, '', 1)

export const formatBytes = (bytes: number) => withUnit(Math.max(0, bytes), BYTE_UNITS, 'Б', 2)

// Единицы: сек, мин, ч, дн, лет. Точность падает с ростом отрезка: 12 лет 100 дн, но 22 мин 10 сек.
export const formatDuration = (ms: number) => {
  const abs = Math.abs(ms)
  const parts: string[] = []
  const push = (value: number, unit: string) => {
    if (value > 0) parts.push(`${value} ${unit}`)
  }
  if (abs >= YEAR) {
    push(Math.floor(abs / YEAR), 'лет')
    push(Math.floor((abs % YEAR) / DAY), 'дн')
  } else if (abs >= DAY) {
    push(Math.floor(abs / DAY), 'дн')
    push(Math.floor((abs % DAY) / HOUR), 'ч')
    push(Math.floor((abs % HOUR) / MIN), 'мин')
  } else if (abs >= HOUR) {
    push(Math.floor(abs / HOUR), 'ч')
    push(Math.floor((abs % HOUR) / MIN), 'мин')
  } else if (abs >= MIN) {
    push(Math.floor(abs / MIN), 'мин')
    push(Math.floor((abs % MIN) / SEC), 'сек')
  }
  if (!parts.length) return `${Math.floor(abs / SEC)} сек`
  return parts.join(' ')
}

export const formatDate = (date: Date) => `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`

const isYesterday = (date: Date, now: Date) => {
  const yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)
  return date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear()
}

// сейчас → сек → мин → ч (до 23) → вчера в 10:00 → 25 ноя 2024
export const formatTimeAgo = (timestamp: number | Date, nowMs = Date.now()) => {
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp)
  const now = new Date(nowMs)
  const diff = nowMs - date.getTime()
  if (diff < SEC) return 'сейчас'
  if (diff < MIN) return `${Math.floor(diff / SEC)} сек назад`
  if (diff < HOUR) return `${Math.floor(diff / MIN)} мин назад`
  if (diff < DAY) return `${Math.floor(diff / HOUR)} ч назад`
  if (isYesterday(date, now)) return `вчера в ${pad(date.getHours())}:${pad(date.getMinutes())}`
  return formatDate(date)
}
